export const checkIfPlayerConfirmedSetupPhase = (playersConfirmedSetupPhase, player) => {
  if (!player) {
    return false;
  }

  return playersConfirmedSetupPhase.includes(player.id)
}